var exports = {
  "k": "x61f99309--27cb26--container",
};

module.exports = exports;
